var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-nav-top"},[_c('h3',[_vm._v("新闻快讯")]),_vm._v(" "),_c('ul',_vm._l((_vm.hyNews),function(item){return _c('li',{key:item.id,on:{"click":function($event){return _vm.newsShow(item.id)}}},[_c('i',{staticClass:"iconfont icon-youjiantoushixinxiao"}),_vm._v(_vm._s(item.title))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4b82930","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pc/NewsNavTop.vue
// module id = null
// module chunks = 